import React from 'react'
import { ThemeProvider } from '@contrast-security-inc/design-system-foundations'

// Extend the Window interface to include isEmbeddedInNS and canApplyDarkTheme
declare global {
  interface Window {
    isEmbeddedInNS?: boolean
    canApplyDarkTheme?: boolean
  }
}

export function wrapWithSkeletorThemeProvider(WrappedComponent) {
  return function SkeletorThemeProvider(props) {
    return (
      <ThemeProvider
        selectedTheme={window.canApplyDarkTheme === true ? 'dark' : 'light'}
      >
        <WrappedComponent {...props} />
      </ThemeProvider>
    )
  }
}
